export default {
  itemDescriptionDefaultColor: undefined as string | undefined,
  itemDescriptionFontSize: 'sm' as const,
  itemDescriptionFontWeight: undefined as undefined,
  itemDescriptionLineHeight: 14,
};
